module.exports = __webpack_public_path__ + "img/POP-00011-3.f84219a2.png";